import { Paper } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  paper: {
    padding: theme.spacing(4),
    paddingTop: theme.spacing(2),
  },
}))

interface Props {
  children: React.ReactNode
}

/**
 * Wrapper component to apply same styling to all tabs of the service dashboard.
 */
const ServiceDashboardPaper: React.FC<Props> = ({ children }) => {
  const { classes } = useStyles()

  return <Paper className={classes.paper}>{children}</Paper>
}

export default ServiceDashboardPaper
